import { Link } from 'react-router-dom'
import { audiomnist } from '../../../assets'
import '../Project.css'

export default function AudioMNIST() {

  window.scrollTo(0, 0)

  return (
    <>
      <div className='project-wrapper'>
        <div className="project-container">
          <div className='project-image-container'>
            <img src={audiomnist} className='project-image'
            alt='Audio MNIST' />
          </div>
          <div className='project-title'>
            <h1>Audio MNIST</h1>
          </div>
          <div className='project-description'>
            <p>This project uses a convolutional neural network to predict spoken digits from 0-9. Once the audio is recorded, it is passed into a spectrogram before being handed to the network for prediction.</p>
          </div>
          <div className='project-links'>
            <Link to='https://owenjrjones.pythonanywhere.com/'
              target='_blank'
              rel='noreferrer'
            >
              <i className='fas fa-external-link-alt'>&nbsp;</i>
              Deployment
            </Link>
            <Link to='https://github.com/OwenJRJones/AUDIO-MNIST'
              target='_blank'
              rel='noreferrer'
            >
              <i className='fab fa-github' >&nbsp;</i>
              GitHub
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
